import styled from '@emotion/styled';
import { Box } from '@mui/system';

import AppTour from '@/src/components/AppTour/AppTour';
import { ReleaseNotesDialog } from '@/src/components/layouts/defaultlayout/ReleaseNotesDialog';
import { useAppRoute } from '@/src/shared/hooks/useAppRoute';

import { ChatContainer } from './ChatContainer';

const ChatsBox = styled(Box)({
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
});

export const Chats = () => {
    const { isPolli } = useAppRoute();
    return (
        <ChatsBox>
            <AppTour />
            <ChatContainer />
            {!isPolli && <ReleaseNotesDialog />}
        </ChatsBox>
    );
};
